import type { ReactionType } from '@genially/p2p-lib';

export const MAX_CONCURRENT_REACTIONS = 20;

export const REACTION_IMAGE: Record<ReactionType, string> = {
  heart: '/resources/reactions/heart.webp',
  'thumb-up': '/resources/reactions/thumb-up.webp',
  confetti: '/resources/reactions/confetti.webp',
  'dance-woman': '/resources/reactions/dance-woman.webp',
  claps: '/resources/reactions/claps.webp',
  lol: '/resources/reactions/lol.webp',
  surprise: '/resources/reactions/surprise.webp',
  cry: '/resources/reactions/cry.webp',
  think: '/resources/reactions/think.webp',
  'thumb-down': '/resources/reactions/thumb-down.webp',
};
